import { SharedService } from './shared.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormService } from './form.service';
import { Router } from '@angular/router';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { TrackService } from '../services/track.service';

@Injectable({
  providedIn: 'root',
})
export class ProposalService {
  calculatedPremiums$;
  phoneNumber: any = null;
  policyRef: any = null;
  email: any = null;
  firstName: any = null;
  lastName: any = null;
  postcode: any = null;
  town: any = null;

  constructor(
    public http: HttpClient,
    public trackService: TrackService,
    public formService: FormService,
    public router: Router,
    private sharedService: SharedService,
    private sessionStorage: SessionStorageService
  ) {}

  setOwnerData(postCode, town) {
    this.postcode = postCode;
    this.town = town;
  }

  setInsurerFirstName(firstName) {
    this.firstName = firstName;
  }
  setInsurerLastName(lastName) {
    this.lastName = lastName;
  }
  setInsurerEmail(email) {
    this.email = email;
  }

  insertTrackingData() {

    const dataCurrentForm = this.formService.currentForm.getRawValue();
    
    let trData = {
      phoneNumber: this.phoneNumber || dataCurrentForm.firstCountryCode +dataCurrentForm.firstPhoneNumber,
      policyRef: this.policyRef,
      email: this.email  || dataCurrentForm.saveOfferOwnerData.email,
      firstName: this.firstName || dataCurrentForm.firstFirstName,
      lastName: this.lastName || dataCurrentForm.saveOfferOwnerData.lastName,
      postcode: this.postcode || dataCurrentForm.postCode,
      town: this.town || dataCurrentForm.cityName,
    };
    return this.http.post(
      '/api/v1/user/step/tracking/notification/create',
      trData
    );
  }

  setPhoneNumber(phoneCode, phoneNumber) {
    this.phoneNumber = phoneCode + phoneNumber;
  }
  trackingFinalData(data) {
    this.trackService.pushEventTracking('product.policyNumber',data.sPlcNomer)

    const dataCurrentForm = this.formService.currentForm.getRawValue();
    
    let trData = {
      phoneNumber: this.phoneNumber || dataCurrentForm.firstCountryCode +dataCurrentForm.firstPhoneNumber,
      policyRef: this.policyRef,
      email: this.email  || dataCurrentForm.saveOfferOwnerData.email,
      firstName: this.firstName || dataCurrentForm.firstFirstName,
      lastName: this.lastName || dataCurrentForm.saveOfferOwnerData.lastName,
      postcode: this.postcode || dataCurrentForm.postCode,
      town: this.town || dataCurrentForm.cityName,
    };
    return this.http.post(
      '/api/v1/user/step/tracking/notification/create',
      trData
    );
  }

  calculatePremiums(item) {
    const dataCurrentForm = this.formService.currentForm.getRawValue();
    const formData = item || dataCurrentForm;
    if (item && dataCurrentForm.movableinsuranceSumRecommended) {
      item.movableinsuranceSumRecommended = dataCurrentForm.movableinsuranceSumRecommended;
    }
    if (item && dataCurrentForm.movableinsuranceSumRecommendedCurr2) {
      item.movableinsuranceSumRecommendedCurr2 = dataCurrentForm.movableinsuranceSumRecommendedCurr2;
    }
    if (item && dataCurrentForm.immovableinsuranceSumRecommended) {
      item.immovableinsuranceSumRecommended =
      dataCurrentForm.immovableinsuranceSumRecommended;
    }
    if (item && dataCurrentForm.immovableinsuranceSumRecommendedCurr2) {
      item.immovableinsuranceSumRecommendedCurr2 = dataCurrentForm.immovableinsuranceSumRecommendedCurr2;
    }
    this.calculatedPremiums$ = this.http
      .post('/api/v1/calculatedPremiums/', formData)
      .pipe(
        tap((data) => {
          let trackingData = {
            phoneNumber: this.phoneNumber || dataCurrentForm.firstCountryCode +dataCurrentForm.firstPhoneNumber,
            policyRef: this.policyRef,
            email: this.email  || dataCurrentForm.saveOfferOwnerData.email,
            firstName: this.firstName || dataCurrentForm.firstFirstName,
            lastName: this.lastName || dataCurrentForm.saveOfferOwnerData.lastName,
            postcode: this.postcode || dataCurrentForm.postCode,
            town: this.town || dataCurrentForm.cityName,
          };
          this.http
            .post(
              '/api/v1/user/step/tracking/notification/create',
              trackingData
            )
            .pipe(catchError((_) => of(data)))
            .subscribe();
        }),
        shareReplay()
      );
  }
}
